import { useState } from "react";
import "./restaurant-menu-categories.styles.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
const RMCategories = ({ categories, moveIntoFolder, addCategory }) => {
  const [newCategory, setNewCategory] = useState("");
  const handleSubmit = (event) => {
    event.preventDefault();
    addCategory(newCategory);
    setNewCategory("");
  };
  const handleChange = (event) => {
    setNewCategory(event.target.value);
  };
  return (
    <div className="rm-categories-container">
      {categories.map((category, index) => {
        return (
          <span
            key={index}
            onClick={() => moveIntoFolder(category)}
            className="rm-categories-link"
          >
            {category}
          </span>
        );
      })}
      <form className="rm-categories-newform" onSubmit={handleSubmit}>
        <input
          type="text"
          className="rm-categories-input"
          placeholder="Add Category"
          onChange={handleChange}
          value={newCategory}
        />
        <button type="submit" className="rm-categories-button">
          <FontAwesomeIcon icon={faPlus} />
        </button>
      </form>
    </div>
  );
};
export default RMCategories;
